<template>
	<div class="three">
		<div class="container">
			<div class="content">
				<ul>
					<li>
						<img src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1552034848563&di=f146469c1028b28a3991288576df36c2&imgtype=0&src=http%3A%2F%2Fimg1.3lian.com%2F2015%2Fa1%2F142%2Fd%2F323.jpg"/>
						<p>雪亮工程是视频门禁解决方案</p>
					</li>
				</ul>
				
				<div class="pages">
					<el-pagination
					  background
					  layout="prev, pager, next"
					  prev-text='上一页'
					  next-text='下一页'
					  @current-change="handleCurrentChange"
					  :total="10">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'two'
			}
		},
		methods:{
			handleChange(val) {
//	        console.log(val);
	      },
		//	      点击的当前页数
	      handleCurrentChange(){
//	      	console.log(this.currentPage1);//当前显示的页数
	      },
		},
		created(){
			
		},
	}
</script>

<style lang="less" scoped="scoped">
.three{
	margin-bottom: 100px;
	.content{
							ul{
								display: flex;
								flex-wrap: wrap;
								justify-content: space-between;
								li{
									display: inline-block;
									width: 32%;
									height: 260px;
									margin-bottom: 25px;
									background: #eee;
									img{
										width: 100%;
										height: 80%;
										padding: 10px;
									}
									p{
										padding: 10px;
										height: 55px;
										width: 100%;
										text-align: center;
										padding-top: 13px;
										color: #146BFF;
										font-size: 18px;
									}
								}
								.active{
									background: #00A0FF;
									color: #fff;
								}
					}
					.pages{
						margin-top: 30px;
						font-size: 20px;
						text-align: right;
					}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Solution/Scom/Three.vue